const ErrorFallback = ({
  resetError,
  error,
}: {
  resetError: () => void;
  error: unknown;
}) => {
  return (
    <div>
      <h2>Something went wrong!</h2>
      <p>
        Error:{" "}
        {error instanceof Error ? error.message : "An unknown error occurred"}
      </p>
      <button onClick={resetError}>Try Again</button>
    </div>
  );
};

export default ErrorFallback;
